import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
    this.setState({
      error,
      errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-background flex items-center justify-center p-4">
          <div className="max-w-2xl w-full bg-card p-6 rounded-lg border">
            <h1 className="text-2xl font-bold text-destructive mb-4">Something went wrong</h1>
            <details className="whitespace-pre-wrap text-sm">
              <summary className="cursor-pointer font-medium mb-2">Error Details</summary>
              <div className="mt-2 p-4 bg-muted rounded">
                <p className="font-bold">{this.state.error && this.state.error.toString()}</p>
                <p className="mt-2 text-xs text-muted-foreground">
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </p>
              </div>
            </details>
            <button 
              onClick={() => window.location.reload()} 
              className="mt-4 px-4 py-2 bg-primary text-primary-foreground rounded"
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
